module.exports = __webpack_public_path__ + "static/img/img-4-11.72c1e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-4-11.png
// module id = 2iYk
// module chunks = 0